import(/* webpackMode: "eager" */ "/vercel/path0/components/Terms.js")